const theme = {
  fonts: {
    primary: 'MQingHuaHK',
    secondary: 'COYuenHK',
    tertiary: 'MHeiHK',
    quaternary: 'MyriadPro',
  },
  palette: {
    primary: ['#56B0E4', '#75BFE9', '#95CDEE', '#B4DCF3', '#D3EAF8'],
    secondary: ['#E51E31', '#EA4555', '#EE6D79', '#F3949D', '#F7BBC1'],
    tertiary: ['#FFD602', '#FFDD2E', '#FFE45B', '#FFEB87', '#FFF2B3'],
    grayscale: ['#000000', '#404040', '#808080', '#A9A9A9', '#D3D3D3', '#F5F5F5', '#FFFFFF'],
    white: ['#FFFFFF'],
  },
  sizes: {
    maxWidth: '1280px',
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
  }
};

export default theme;
